import { useEffect } from 'react';
import { useKeycloak } from '../shared/auth/KeycloakProvider.tsx';
import { useNavigate } from '@tanstack/react-router';
import { restApiUrl } from '../shared/helpers/backendUrl';

interface RedirectToLoginAndBackProps {
  target?: string;
}

export const RedirectToLoginAndBack: React.FC<RedirectToLoginAndBackProps> = ({
  target,
}) => {
  const { login, authenticated } = useKeycloak();
  const navigate = useNavigate();

  useEffect(() => {
    if (authenticated) {
      if (target) {
        navigate({
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          to: (target.startsWith('/') ? target : '/' + target) as any,
        });
      }
      return;
    }

    const href = window.location.href;
    const redirectUri = target?.startsWith('/')
      ? `${window.location.origin}${window.__BTS_EMBED_BASE_PREFIX__ ?? ''}${target}`
      : href + (href.endsWith('/') ? '' : '/') + (target || '');

    login(redirectUri).catch(() => {
      window.location.href = restApiUrl(
        `/auth/login?successRef=${encodeURIComponent(redirectUri)}`,
      );
    });
  }, [login, target, authenticated, navigate]);

  return null;
};
